module.exports = __webpack_public_path__ + "static/samsung-pay-129accbfee037f02211d1523808b8de0.svg";